// extracted by mini-css-extract-plugin
export default {"footerTitle":"ServicesPageFooter_footerTitle__hwG7m","serviceFooter":"ServicesPageFooter_serviceFooter__CBGoE"};